import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  Input, OnChanges, 
  
  
} from '@angular/core';



import type { BuyersSelectComponent as OriginalComponent } from '../../components/buyers-select/buyers-select.component';

@Component({
  selector: 'ish-lazy-buyers-select',
  templateUrl: './lazy-buyers-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyBuyersSelectComponent implements OnInit , OnChanges {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component components/buyers-select/buyers-select.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;


  @Input() control: OriginalComponent['control'];

  @Input() field: OriginalComponent['field'];


  private component: ComponentRef<OriginalComponent>;
  

  constructor(
    
    private injector: Injector
  ) {}

  async ngOnInit() {
    

      await this.renderComponent();

    
  }

  private async renderComponent() {
    const module = await import(`../../organization-management.module`).then(m => m.OrganizationManagementModule);

    const { BuyersSelectComponent: originalComponent } = await import('../../components/buyers-select/buyers-select.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.ngOnChanges(
      
    );
  
    this.component.changeDetectorRef.markForCheck();
  }


  ngOnChanges() {
    if (this.component) {
      
        this.component.instance.control = this.control;
      
        this.component.instance.field = this.field;
      

      
    }
  }

}
